

<!DOCTYPE html>

<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script>
  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.0.8/css/all.css">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">
</head>






<div class="card" *ngIf="ShowCard===2">
  <div class="card-body">
<br>
    <div class="row">
      <p style="color: #6ab187;"><strong>EMPLOYEE SCREENING</strong></p>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/users.png"><a style="text-decoration: none;color:black" routerLink="/whitecollar"> <strong class="white">&nbsp; White-collar verification</strong></a></div>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/mechanic.png"><a style="text-decoration: none;color: black;"  routerLink="/bluecollar"><strong class="white"> Blue-collar verification</strong></a></div>
      <br><br>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/online-business.png"><a style="text-decoration: none;color: black;" routerLink="/gigworker"> &nbsp;<strong class="white"> Gig Worker verification</strong></a></div>
    </div>
    <br>
    
    <div class="row">
      
      <p style="color: #6ab187;"><strong>RISK & COMPLIANCE</strong></p>
      <div class="col-3"><img style="width: 30px;height: auto;" src="assets/risktopicon.png"><a style="text-decoration: none;color: black;" routerLink="/riskmanage"><strong class="white"> Risk Management</strong></a></div>
      <div class="col-3"><img style="width: 35px;height: auto;" src="assets/onboarding.png"><a style="text-decoration: none;color: black;" routerLink="/vendor"><strong class="white" > Vendor Onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/distributortopicon.png"><a style="text-decoration: none;color: black;" routerLink="/distribute"><strong class="white"> Distributor onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/duediligence.jpg"><a style="text-decoration: none;color: black;" routerLink="/duediligence"><strong class="white"> Due Diligence</strong> </a></div>
    </div>
    <br>
  
    <!--  -->
    <div class="row">
      
      <p style="color: #6ab187;"><strong> FINANCIAL INTELLIGENCE</strong></p>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/kycsolution.png"><a style="text-decoration: none;color: black;" routerLink="/kycsolution"><strong class="white"> KYC solutions</strong> </a></div>
    </div>
    <br>
  
  </div>
</div>


<div class="card" *ngIf="ShowCard===1">
  <div class="card-body">
<br>
<p style="color: #6ab187;font-weight: 600;"><strong>PRODUCT</strong></p>

    <div class="row">
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" (click)="ShowCard=3"><strong class="white"><img style="width: 4%;height: 100%;" src="assets/docverify.png"> Document Verification</strong> </a></div>
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" routerLink="/service"><strong class="white"><img style="width: 5%;height: 110%;" src="assets/docsignin.png"> Document SignIn</strong> </a></div>
  
    </div>
    <br>

    <div class="row">
       </div>
    <br>
    
  </div>
</div>


<!--  -->

<div class="card" *ngIf="ShowCard===3">
  <div class="card-body">
    <br>
<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/aadhartopicon.png"><a style="text-decoration: none;color: black;" routerLink="/aadhaar"> <strong class="white"> Aadhaar verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/pantopicon.png"><a style="text-decoration: none;color: black;"  routerLink="/pan"><strong class="white"> Pan verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/gsttopicon.jpg"><a style="text-decoration: none;color: black;" routerLink="/gst"><strong class="white"> Gst verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/drivinglicensetop.jpg"><a style="text-decoration: none;color: black;" routerLink="/driving"><strong class="white"> Driving verification</strong></a></div>
</div><br><br>

<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/passporttopicon.png"><a style="text-decoration: none;color: black;" routerLink="/passport"><strong class="white"> Passport verification</strong> </a></div>
  <div class="col"><img style="width: 58px;height: 44px;" src="assets/rcverify.png"><a style="text-decoration: none;color: black;" routerLink="/rcverify"><strong class="white"> RC verification</strong></a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/msmeverify.png"><a style="text-decoration: none;color: black;" routerLink="/msmeverify"><strong class="white"> MSME verification</strong> </a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/verification.png"><a style="text-decoration: none;color: black;" routerLink="/dinverify"><strong class="white"> DIN verification</strong></a></div>
</div>

<br><br>
<div class="row">
  <div class="col-3"><img style="width: 35px;height: 44px;border-radius: 20px;" src="assets/cinicon.png"><a style="text-decoration: none;color: black;" routerLink="/cinverify"><strong  class="white"> CIN verification</strong></a></div>
</div>
</div>
</div>


<br><br>



<!-- topic -->
<div class="row"  data-aos="zoom-in" data-aos-delay="300"  >
  <div class="col-md-6 text-center">
    <img style="width:70%;height: 100%;margin-top: 40px;border-radius: 50% 60%;" src="assets/rcverifytopic.png">
</div>
    <div style="padding-top: 10%;" class="col-md-6">
        <h1>
            <span class="topic">Real time Vehicle RC Verification with Plug & Play API’s </span>
          </h1>
        <h5 style="padding-left: 10%;">&nbsp;&nbsp;&nbsp;Real Time KYC of owner and registration verification of vehicle with RTO while purchase or resale</h5>
    </div>

    
</div>
<br><br>
<br><br>


<div class="row" data-aos="zoom-in" data-aos-delay="300"   >
    <div class="col">
       
            <h2 style="text-align: center;font-size: 550;color: #6ab187;">Why do you require Vehicle RC Verification?</h2>
        <h4 style="color: gray;text-align: center;">To use as a Valid document for identity proof for a Vehicle owner</h4>
    </div>
    </div>
    <br><br><br>
  
       
  <div class="row p-2">
  
    <div data-aos="fade-up" data-aos-delay="300"  class="col-md-4">
        <br>
        <img style="width: 60px;height: 65px;" src="assets/formrc.png">
       <br><br>
        <h5 >Tampering with Vehicle RC details</h5>
        <p style="align-items: center;">Fraudsters may  tamper with the information on the RC, such as changing vehicle details, engine numbers, or chassis numbers, to misrepresent the vehicle’s identity.</p>
    </div>
  
    <div data-aos="fade-up" data-aos-delay="300" class="col-md-4">
          <br>
          <img style="width: 70px;height: 60px;" src="assets/fakerc.jpg">
         <br><br>
          <h5>Forgery and fake RCs for Identity Fraud</h5>
          <p style="align-items: center;">Fraudsters may create fake or forged RC documents with fictitious vehicle details to sell stolen vehicles or conceal the true identity of the vehicle.</p>
      </div>
     
      <div data-aos="fade-up" data-aos-delay="300" class="col-md-4">
     
        <br>
        <img style="width: 60px;height: 60px;" src="assets/loanrc.png">
       <br><br>
        <h5 >Misuse of RC for loan against Vehicle</h5>
        <p style="align-items: center;">Scammers may attempt to deceive financial institutions by using fake Registration Certificates (RCs) to secure loans against vehicle<p>
    </div>
  
  </div>
  
  <br><br>


  
<div class="row" data-aos="zoom-in" data-aos-delay="300"  >
    <div style="text-align: center;" class="col">
      <h1 style="color: #6ab187;">Types of Vehicle RC Verification API's</h1>
      <h6 style="color: gray;">Streamline Vehicle ownership verification with AuthBridge’s Vehicle RC Verification API</h6>
      <br><br>
    </div>
  
  
  <br><br>
  </div>
  <div  class="row p-3">
  
    <div data-aos="fade-up" data-aos-delay="300"  class="col-md-4">
        <br>
        <img style="width: 60px;height: 65px;" src="assets/verifyvehicle.png">
       <br><br>
        <h5>Stolen Vehicle Verification</h5>
        <p style="align-items: center;">Stolen Vehicle Police complaint check 
            via RC number </p>
    </div>
  
    <div data-aos="fade-up" data-aos-delay="300" class="col-md-4">
          <br>
          <img style="width: 78px;height: 60px;" src="assets/rcverifyvehicle.jpg">
         <br><br>
          <h5>Vehicle Registration Check</h5>
          <p style="align-items: center;">Get complete Vehicle details from registration dates to chassis #, manufacturer and registration authority</p>
      </div>
     
      <div data-aos="fade-up" data-aos-delay="300" class="col-md-4">
     
        <br>
        <img style="width: 60px;height: 60px;" src="assets/registervehicle.jpg">
       <br><br>
        <h5 >Vehicle RC Verification</h5>
        <p style="align-items: center;">Get Vehicle registration details inclusive of Owner’s details, Hypothecation details, Insurance details and RC status<p>
    </div>
  
  </div>

  


  <!-- advantages -->
  
<div class="row"  data-aos="zoom-in" data-aos-delay="300" >
    <div class="col">
            <h2 style="text-align: center;font-size: 550;color: #6ab187;">Facheck’s Vehicle RC Verification API’s Advantages</h2>
    </div>
    </div>
    <br>
  
     
  <div  class="row p-3">
  
    <div style="background-color: #eff8ff;"  class="col-md-4"  data-aos="fade-up" data-aos-delay="300"  >
        <br>
        <img style="width: 60px;height: 65px;background-color: #eff8ff;" src="assets/easy.png">
       <br><br><br>
        <h5>Easy To Use</h5>
        <p style="align-items: center;">Facheck’s Vehicle RC Verification API’s are optimized for
          seamless user experience </p>
    </div>
  
    <div style="background-color: #c9d9e6;" class="col-md-4"  data-aos="fade-up" data-aos-delay="300"  >
          <br>
          <img style="width: 70px;height: 80px;" src="assets/complaint.png">
         <br><br>
          <h5 >Stay Compliant</h5>
          <p style="align-items: center;">Verify all information provided with the Vehicle registration
            department and Police to ensure they are legit and accur</p>
      </div>
     
      <div  style="background-color: #eff8ff;" class="col-md-4"  data-aos="fade-up" data-aos-delay="300"  >
     
        <br>
        <img style="width: 60px;height: 60px;" src="assets/identity.png">
       <br><br><br>
        <h5 >Prevents Identity Frauds</h5>
        <p style="align-items: center;">Our API detects fake or tampered RC cards for
          Identity frauds or Stolen vehicles<p>
    </div>
    <div style="background-color: #eff8ff;"  class="col-md-4"  data-aos="fade-up" data-aos-delay="300"  >
      <br>
      <img style="width: 67px;height: 69px;background-color: #eff8ff;" src="assets/realtime-removebg-preview.png">
     <br><br>
      <h5>Real-Time Verification</h5>
      <p style="align-items: center;">Identity Data and Vehicle stolen information is
        retrieved and verified within a few seconds – saving y
      </p>
  </div>

  <div style="background-color: #c9d9e6;" class="col-md-4"  data-aos="fade-up" data-aos-delay="300"  >
        <br>
        <img style="width: 70px;height: 80px;" src="assets/play&plug.png">
       <br><br>
        <h5 >Plug and Play API’s</h5>
        <p style="align-items: center;">Web portal, APIs, and Mobile SDK with no third-party
          assistance, seamless integration in your onboarding journe</p>
    </div>
   
    <div  style="background-color: #eff8ff;" class="col-md-4"  data-aos="fade-up" data-aos-delay="300"  >
   
      <br>
      <img style="width: 60px;height: 60px;margin-top: 20px;" src="assets/onboard.png">
     <br><br><br>
      <h5 >Instant Onboarding</h5>
      <p style="align-items: center;">Onboard Right Vehicle owners or sell loans against
        asset to the right owners and complete the jo<p>
  </div>

  </div>
  
  
  


  
  <!-- faq -->
  <div data-aos="zoom-in" data-aos-delay="300" class="faq-title text-center pb-3">
    <h2>FAQ</h2>
</div>


<div class="row"  data-aos="fade-up" data-aos-delay="300">
  <div id="slide" style="margin-top: 15%;" class="col-md-6">
    <h1 style="text-align:center;color: #6ab187;">FACheck's FAQ</h1>
   </div>

    <div class="col-md-6">
        <div style="width: 90%;" class="faq-content">
            <div class="faq-question">
              <input id="q1" type="checkbox" class="panel">
             
              <img style="width: 30px;height: 30px;margin-top: 13px;" class="plus" src="assets/handlogo.png">
              <label for="q1" class="panel-title"> &nbsp;&nbsp; What is the Vehicle RC Verification API? </label>
              <div class="panel-content">The Vehicle RC (Registration Certificate) Verification API is a service that allows you to verify the details of a vehicle’s registration certificate (RC) in India.</div>
            </div>
            
            <div class="faq-question">
              <input id="q2" type="checkbox" class="panel">
              <img style="width: 30px;height: 30px;margin-top: 13px;" class="plus" src="assets/handlogo.png">
              <label for="q2" class="panel-title">&nbsp;&nbsp; Why should Businesses Leverage the Vehicle RC Verification API?  </label>
              <div class="panel-content">This API is typically used by organizations such as insurance companies, banks, and car dealerships to verify the authenticity and accuracy of a vehicle’s RC before issuing a policy, loan, or sale.</div>
            </div>
            
            <div class="faq-question">
              <input id="q3" type="checkbox" class="panel">
              <img style="width: 30px;height: 30px;margin-top: 13px;" class="plus" src="assets/handlogo.png">
              <label for="q3" class="panel-title">&nbsp;&nbsp; What attributes can we verify using vehicle RC Verification API?   </label>
              <div class="panel-content">The API will return information such as the vehicle’s make and model, year of manufacture, engine and chassis number, and the name and address of the registered owner.</div>
            </div>
        
            <div class="faq-question">
                <input id="q4" type="checkbox" class="panel">
                
               <img style="width: 30px;height: 30px;margin-top: 13px;" class="plus" src="assets/handlogo.png">
                <label for="q4" class="panel-title">&nbsp;&nbsp; How does the Vehicle RC Verification API work? </label>
                <div class="panel-content">The Vehicle RC Verification API works by accessing a database of vehicle registration information maintained by the government of India. When you submit a request to the API with the vehicle’s registration number and the state in which it is registered, the API sends a request to the government database to retrieve the information associated with that particular vehicle. The API then processes the response from the government database and formats the information in a way that is easy for you to use and understand.</div>
              </div>
              
              <div class="faq-question">
                <input id="q5" type="checkbox" class="panel">
                
               <img style="width: 30px;height: 30px;margin-top: 13px;" class="plus" src="assets/handlogo.png">
                <label for="q5" class="panel-title">&nbsp;&nbsp;What programming languages does it support?  </label>
                <div class="panel-content">The Vehicle RC Verification API can be accessed using any programming language that supports HTTP requests, such as Python, Java, or C#. There are also a number of third-party tools and libraries that can be used to make it easier to access the API and retrieve the information that you need.</div>
              </div>

          </div>
    </div>
  

</div>


 






